import i18nFactory from '@yandex-int/i18n';

import { BudgetType, DayBudgetValue } from '../../typings/budget';
import { ValidationResult } from '../../typings/common';
import { DailyBudgetLimit } from '../../typings/constants';
import { GdCampaignBudgetShowMode } from '../../typings/graphql-grid';
import { formatNumber } from '../FormatHelpers/FormatHelpers';

import * as keyset from './DayBudget.i18n';

const i18n = i18nFactory(keyset);

export function validateDayBudgetValue(value: DayBudgetValue, constants: DailyBudgetLimit): ValidationResult {
    const errors = [];
    const { minDailyBudget, maxDailyBudget } = constants,
        { isActive, sum } = value;

    if (isActive && sum === 0) {
        errors.push({
            type: 'required',
            text: i18n('requiredMessage'),
            path: 'sum'
        });
    }

    if (isActive && sum < minDailyBudget) {
        errors.push({
            type: 'lte',
            text: i18n('lteMessage', {
                minValue: formatNumber(minDailyBudget, 2)
            }),
            path: 'sum'
        });
    }

    if (isActive && sum > maxDailyBudget) {
        errors.push({
            type: 'gte',
            text: i18n('gteMessage', {
                maxValue: formatNumber(maxDailyBudget, 2)
            }),
            path: 'sum'
        });
    }

    return errors.length
        ? {
              valid: false,
              errors: errors
          }
        : {
              valid: true
          };
}

export function getDefaultDayBudgetValue(): DayBudgetValue {
    return {
        type: BudgetType.day,
        isActive: false,
        sum: 0,
        mode: GdCampaignBudgetShowMode.DEFAULT
    };
}
